module.exports = __webpack_public_path__ + "static/media/register-success.ea1ebe31.svg";